export const MAX_COMPANY_NAME_LENGTH = 25;
export const MAX_COMPANY_DESCRIPTION_AND_MEMO_LENGTH = 50;
